import { useFirestoreQueryData } from "@react-query-firebase/firestore";
import { WorkspaceAccess } from "../models";
import { useCache } from "../context/CacheContext";
import { useWorkspace } from "../context/WorkspaceContext";
import { queryKeys } from "../data/queryKeys";

const useWorkspaceUsers = (workspaceId?: string) => {
  const { cacheKey } = useCache();
  const { activeWorkspace } = useWorkspace();
  const resolvedWorkspaceId = workspaceId ?? activeWorkspace?.workspaceId ?? "";

  return useFirestoreQueryData(
    queryKeys.workspaceUsers(cacheKey, resolvedWorkspaceId),
    WorkspaceAccess.getWorkspaceUser(resolvedWorkspaceId),
    {
      subscribe: false,
    },
    {
      enabled: !!resolvedWorkspaceId,
    }
  );
};

export default useWorkspaceUsers;
